export default __webpack_public_path__ + "static/media/5.18f7f8ed.png";